import React from 'react';
import { colors, Icon } from 'kangarootime-ui';
import { Button, withStyles } from '@material-ui/core';

const CustomDownloadButton = withStyles(theme => ({
  root: {
    minWidth: 24
  }
}))(Button);

const DownloadButton = ({
  ...props
}) => {
  const downloadAttachment = event => {
    event.preventDefault();

    let link = document.createElement('a');
    link.target = '_blank';
    link.href = props.attachment.url;
    link.download = props.attachment.key;
    document.body.appendChild(link);
    link.click();
  };

  return (
    <CustomDownloadButton size='small' variant='outlined' onClick={downloadAttachment}>
      <Icon icon='cloud-download' color={colors.brand_4} height={14} width={14} />
    </CustomDownloadButton>
  );
};

DownloadButton.propTypes = {

};

export default DownloadButton;
